var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.catalog)?[(this.$vuetify.breakpoint.mobile)?_c('catalog-mobile',{attrs:{"catalog":_vm.catalog}}):_c('catalog-desktop',{attrs:{"catalog":_vm.catalog}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }